module.exports = __webpack_public_path__ + "static/media/livechat.9582f27b.svg";